export enum ERowReaderMode {
  DEFAULT = 'DEFAULT',
  COMPARISON = 'COMPARISON',
  TOTALS = 'TOTALS',
  COMPARISON_TOTALS = 'COMPARISON_TOTALS',
  /** Subtotal of the first GROUP BY dimension (`WITH GROUP_TOTALS`); needs the dimension name to resolve. */
  GROUP_TOTALS = 'GROUP_TOTALS',
}
